<template>
  <div class="view">
    <div class="view__inner">
      <div class="text-center">
        <SVGLogo class="view__logo" />
      </div>

      <FormResetPassword class="m-t-1" />

      <Separator class="m-t-2" :show-line="true" :text="$t('or')"></Separator>

      <p class="text-center m-t-1">
        <router-link tag="el-button" :to="{ path: '/login' }" class="w-100 m-t-1">
          {{ $t('Login') }}
        </router-link>
      </p>
    </div>

    <p class="view__footer">
      <a href="https://gpal.epal-pallets.org/menus/menu-marginal/impressum/" target="_blank" :title="$t('Imprint')" class="color-gray">{{
        $t('Imprint')
      }}</a>
    </p>
  </div>
</template>

<script>
import FormResetPassword from '@/components/Form/FormResetPassword';
import Separator from '@/components/Misc/Separator';
import SVGLogo from '@/assets/img/epal-deutschland-black.svg';

export default {
  name: 'ResetPassword',

  components: {
    FormResetPassword,
    Separator,
    SVGLogo
  }
};
</script>

<style lang="scss" scoped></style>
